import React, {useContext} from "react";
import Img from "../../common/Img";
import MainButton from "../../common/MainButton";
import lbl from "../../../data/Labels.json";
import MainTitle from "../../common/MainTitle";
import {PopUpContext} from "../../../contexts/popUpContext";

const ClassInfo = ({student, studentInfo, callback}) => {
    const {togglePopUp} = useContext(PopUpContext);

    return (
        <div className="student-info">
            <div className="main-content-header">
                <div className="left-content">
                    {studentInfo ? <MainButton
                        type="pen"
                        title={lbl.Edit}
                        handleClick={() => togglePopUp({
                            form: "student-class-info-form",
                            edit: studentInfo,
                            student: student,
                            callback: callback,
                        })}
                    /> : ''}
                </div>
                <div className="right-content">
                    <MainTitle title="رشته"/>
                </div>
            </div>
            <div className="student-detail">
                <div className="detail_item">
                    <p>رشته</p>
                    <p>{studentInfo?.selected_faculty_name}</p>
                </div>
                <div className="detail_item">
                    <p>دوره</p>
                    <p>{studentInfo?.selected_time_name}</p>
                </div>
                <div className="detail_item">
                    <p>دپارتمنت</p>
                    <p>{studentInfo?.selected_department_name}</p>
                </div>
            </div>
        </div>
    );
};

export default ClassInfo;
